import React, { useMemo } from "react";
import { InstantSearch } from "react-instantsearch";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { RelatedContentBlock } from "../../lib/storyblok/types/blocks/RelatedContentBlock";
import { useViewmodel } from "../../lib/storyblok/ViewmodelContext";
import {
  initAlgoliaIndecies,
  initAlgoliaSearch,
} from "../../lib/utils/AlgoliaSearchHelpers";
import RelatedContentHits from "./RelatedContentHits";
import { useContentStyle } from "../../hooks/useStyle";
import { useLinks } from "../../lib/storyblok/useLinks";
import Button from "../../ui/Button";

const indecies = initAlgoliaIndecies();
const searchClient = initAlgoliaSearch();

const RelatedContent: StoryblokBlockComponent<RelatedContentBlock> = (
  props
) => {
  const {
    title,
    description,
    products = [],
    solutions = [],
    contentType,
    buttons,
    style = "none",
    innerSpacing,
    outerSpacing,
    contentLayout,
    storiesCount,
  } = props;

  const isInverted = useContentStyle(style);
  const { locale } = useViewmodel();
  const resolveLink = useLinks();

  const buttonCollection = useMemo(() => {
    if (!buttons || !Array.isArray(buttons)) return buttons;

    return buttons.map((button) => (
      <Button
        variant={button.buttonType ?? "default"}
        key={button._uid}
        href={button.buttonLink ? resolveLink(button.buttonLink) : "#"}
      >
        {button.buttonText}
      </Button>
    ));
  }, [buttons, resolveLink]);

  return (
    <InstantSearch
      indexName={indecies[locale]}
      searchClient={searchClient}
      insights={true}
    >
      <RelatedContentHits
        title={title}
        description={description}
        style={style}
        innerSpacing={innerSpacing}
        outerSpacing={outerSpacing}
        contentType={contentType}
        products={products}
        solutions={solutions}
        storiesCount={storiesCount}
        inverted={isInverted}
        buttons={buttonCollection}
        contentLayout={contentLayout}
      />
    </InstantSearch>
  );
};

export default RelatedContent;
